module.exports = __webpack_public_path__ + "img/aging_cure.cd2d261e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aging_cure.gif
// module id = NYs6
// module chunks = 0